import React from 'react';
import classnames from 'classnames';

import { PriceBadgeSVG } from '../../Global/Icons';

function PriceBadge({ price, isHover, isClick, unpurchased, loading, offline, success }) {
	const classes = classnames('pet-picker__list__item__price-badge', {
		'pet-picker__list__item__price-badge--is-hover': isHover,
		'pet-picker__list__item__price-badge--is-click': isClick,
		'pet-picker__list__item__price-badge--is-unpurchased': unpurchased,
		'pet-picker__list__item__price-badge--purchase-loading': loading,
		'pet-picker__list__item__price-badge--purchase-success': success,
		'pet-picker__list__item__price-badge--is-offline': offline,
	});

	return (
		<div className={classes}>
			<PriceBadgeSVG />
			<div className="price-badge__price">
				<div className="price-badge__buy-for">Buy for</div>
				${price}
			</div>
			<div className="price-badge__offline">
				You’re Offline
			</div>
		</div>
	);
}

export default PriceBadge;



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/PriceBadge.js